import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pledge',
  templateUrl: './pledge.component.html',
  styleUrls: ['./pledge.component.css']
})
export class PledgeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
